import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDialogs } from "../hooks/use-dialogs";
import useLivrariaModel from "../model/livraria";
import useLivroModel from "../model/livro";
import { Livro } from "../types/general";
import useLivrariaStore from "../zustand/use-livraria-store";
import useLivroStore from "../zustand/use-livro-store";

export const ViewModelLivro = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const livrariaIdParam = searchParams.get("livraria");

  const {
    livros,
    selectedLivro,
    selectedLivrariaId,
    setSelectedLivro,
    setSelectedLivrariaId,
  } = useLivroStore();

  const {
    fetchLivrarias
  } = useLivrariaModel();

  const { livrarias, } = useLivrariaStore();

  const {
    fetchLivros,
    fetchLivrosByLivraria,
    fetchSuggestions,
    createLivro,
    suggestLivro,
    updateLivroById,
    validateLivro,
    rejectLivro,
    deleteLivroById,
  } = useLivroModel();

  const {
    close,
    dialog,
    showConfirmation,
    showSuccess,
    showError,
    showWarning,
  } = useDialogs();

  // Select livro for editing
  const selectLivro = (livro: Livro) => {
    setSelectedLivro(livro);
  };

  // Clear selection
  const clearSelection = () => {
    setSelectedLivro(undefined as any);
  };

  // Navigate back to livrarias
  const goToLivrarias = () => {
    navigate("/livrarias");
  };

  useEffect(() => {
    if (livrarias.data.length === 0) {
      fetchLivrarias();
    }
    if (livrariaIdParam) {
      fetchLivrosByLivraria(Number(livrariaIdParam))
    } else {
      fetchLivros();
    }
  }, [])

  const handleDeleteLivro = (id: number) => {
    close();
    deleteLivroById(id, {
      response: () => {
        showSuccess({
          title: 'Sucesso',
          message: 'Livro removido com sucesso!'
        });
      },
      error: () => {
        showError({
          title: 'Erro',
          message: 'Ocorreu erro ao remover o livro!',
        })
      }
    })
  }

  const handleActionLivro = (livro: Livro, action: 'add' | 'update') => {
    if (action === 'add') {
      createLivro({
        title: livro.title,
        shared: livro.shared,
        url: livro.url,
        type: livro.type,
        author: livro.author,
        livrariaId: livro.livraria_id || 0,
      }, {
        response: () => {
          showSuccess({
            title: 'Sucesso',
            message: 'Livro criado com sucesso!'
          });
        },
        error: (error) => {
          console.log(error)
          showError({
            title: 'Erro',
            message: 'Ocorreu erro ao criar o livro!',
          })
        }
      });
    } else {
      updateLivroById(livro, {
        response: () => {
          showSuccess({
            title: 'Sucesso',
            message: 'Livro actualizado com sucesso!'
          });
        },
        error: () => {
          showError({
            title: 'Erro',
            message: 'Ocorreu erro ao actualizar o livro!',
          })
        }
      });
    }
  }

  const handleValidateLivro = (id: number) => {
    close();
    validateLivro(id, {
      response: () => {
        showSuccess({
          title: 'Sucesso',
          message: 'Livro validado com sucesso!'
        });
      },
      error: () => {
        showError({
          title: 'Erro',
          message: 'Ocorreu erro ao validar o livro!',
        })
      }
    })
  }

  const handleRejectLivro = (id: number) => {
    close();
    rejectLivro(id, {
      response: () => {
        showSuccess({
          title: 'Sucesso',
          message: 'Livro rejeitado com sucesso!'
        });
      },
      error: () => {
        showError({
          title: 'Erro',
          message: 'Ocorreu erro ao rejeitar o livro!',
        })
      }
    })
  }

  return {
    // State
    livros,
    selectedLivro,
    selectedLivrariaId,
    livrarias,
    livrariaIdParam,
    // Actions
    fetchLivros,
    fetchLivrosByLivraria,
    fetchSuggestions,
    handleActionLivro,
    handleDeleteLivro,
    handleValidateLivro,
    handleRejectLivro,
    selectLivro,
    clearSelection,
    goToLivrarias,
    navigate,
    // Dialogs
    dialog,
    showConfirmation,
    showSuccess,
    showError,
    showWarning,
  };
};
